import 'babel-polyfill'
// require('es6-promise').polyfill()
// require('es6-promise/auto')
require('promise.prototype.finally').shim()
require('promise.allsettled').shim()

import Vue from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import '@/styles/element/element-variables.scss'
import '@/styles/index.scss'
import '@/assets/font/iconfont/iconfont.css'
import JczhUI from 'jczh-ui'
import './permission'
import WujieVue from 'wujie-vue2'
import '@/utils/wujie/wujie'

import { bankCardFilter } from '@/utils/utils'
import { systemConfirm } from '@/utils/ant-utils'
// 控制vue调试工具
// TODO：暂时开启开发环境的vue调试工具
const isDebug_mode =
  process.env.NODE_ENV.indexOf('local') > -1 ||
  process.env.NODE_ENV === 'development'
Vue.config.debug = isDebug_mode
Vue.config.devtools = isDebug_mode
Vue.config.productionTip = isDebug_mode

// 引入全局的工具函数
Vue.prototype.$bankCardFilter = bankCardFilter
Vue.prototype.$systemConfirm = systemConfirm

Vue.use(VueDOMPurifyHTML)
Vue.use(ElementUI, { size: 'small' })
Vue.use(JczhUI)
import directive from '@/directive'
Vue.use(directive)
Vue.use(WujieVue)

import filters from '@/filters'
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

Vue.config.productionTip = false

import '@/plugin/ant-design.js'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV === 'production') {
  // console.log = () => {}
}
